import { DataModel } from "../../../../lib/data/model/DataModel.js";

export class FileModel extends DataModel {

    static _instance = null;

    static getInstance(authManager) {

        if (FileModel._instance == null) FileModel._instance = new FileModel(authManager);
        return FileModel._instance;

    }

    constructor (authManager) {

        super(authManager, 'core/files');

        this.entityName = 'core.File';
        this.privileges = {
            create: [["adminFileStorage"],["useFileStorage"]],
            read: [["adminFileStorage"],["useFileStorage"]],
            update: [["adminFileStorage"],["useFileStorage"]],
            delete: [["adminFileStorage"],["useFileStorage"]],
        };

        this.label = 'Soubor';
        this.setLabel = 'Soubory';

        this.browser = {
            name: 'default-core-file-browser',
            moduleName: 'default-core-file-browser',
            moduleTitle: 'Soubory',
            moduleStateSlotName: 'default-core-file-browser',
        };

        this.editor = {
            name: 'default-core-file-editor',
            moduleName: 'default-core-file-editor',
            moduleTitle: 'Soubor',
            moduleStateSlotName: 'default-core-file-editor',
        };

        this.fieldDefs = [
            {
                name: 'id',
                type: 'int',
                persistent: true,
                label: '#ID',
                primaryKey: true,
                required: true,
                readOnly: true,
            },
            {
                name: 'uid',
                type: 'string',
                persistent: true,
                label: 'Unique ID',
                required: true,
                readOnly: true,
            },
            {
                name: 'name',
                type: 'string',
                persistent: true,
                label: 'Name',
                required: true,
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'description',
                type: 'text',
                persistent: true,
                label: 'Description',
                inEditor: true,
                filterable: true,
            },
            {
                name: 'notes',
                type: 'text',
                persistent: true,
                label: 'Notes',
                inEditor: true,
                filterable: true,
            },
            {
                name: 'parentFolderId',
                type: 'Folder',
                persistent: true,
                label: 'Rodičovský adresář',
            },
            {
                name: 'parentFolderUid',
                type: 'string',
                persistent: false,
                label: 'Parent Folder UId',
                readOnly: true,
            },
            {
                name: 'size',
                type: 'int',
                persistent: true,
                label: 'Size',
                readOnly: true,
                inEditor: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'mimeType',
                type: 'string',
                persistent: true,
                label: 'MIME Type',
            },
            {
                name: 'fileTypeId',
                type: 'FileType',
                persistent: true,
                label: 'File Type',
            },
            {
                name: 'fileTypeLabel',
                type: 'string',
                persistent: false,
                label: 'File Type',
                distinctLabel: 'File Type (text)',
                readOnly: true,
            },
            {
                name: 'fileTypeIcon',
                type: 'string',
                persistent: false,
                label: 'Icon',
                readOnly: true,
            },
            {
                name: 'createdAt',
                type: 'utc_datetime',
                persistent: true,
                label: 'Created At',
                readOnly: true,
                inEditor: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'createdById',
                type: 'User',
                persistent: true,
                label: 'Created By',
                inEditor: true,
                filterable: true,
            },
            {
                name: 'createdByLabel',
                type: 'string',
                persistent: false,
                label: 'Created By',
                distinctLabel: 'Created By (Name)',
                readOnly: true,
                inEditor: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'updatedAt',
                type: 'utc_datetime',
                persistent: true,
                label: 'Changed At',
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'updatedById',
                type: 'User',
                persistent: true,
                label: 'Changed By',
                inEditor: true,
                filterable: true,
            },
            {
                name: 'updatedByLabel',
                type: 'string',
                persistent: false,
                label: 'Changed By',
                distinctLabel: 'Updated By (Name)',
                readOnly: true,
                inEditor: true,
                filterable: true,
                orderable: true,
            },
        ];

    }

}
